<div class="journal">
    <div class="journal__header px-16 py-8">
        <h3>{{ "table.filters" | translate }}</h3>

        <div class="flex flex-wrap align-center gap-8">
            @if (showProjectFilter()) {
                <app-table-filter
                    [column]="projectColumn"
                    [isOutsideTable]="true"
                    [table]="table"
                ></app-table-filter>
            }

            <app-table-filter
                [column]="categoriesColumn"
                [isOutsideTable]="true"
                [table]="table"
            ></app-table-filter>

            <app-table-filter
                [column]="timestampColumn"
                [isOutsideTable]="true"
                [table]="table"
            ></app-table-filter>

            @if (project) {
                <app-table-filter
                    [column]="includeAllColumn"
                    [isOutsideTable]="true"
                    [table]="table"
                ></app-table-filter>
            }
        </div>

        <div class="m-btn-group m-btn-group-right">
            @if (createCommand && !readonly) {
                <button
                    class="m-btn m-btn-secondary"
                    id="add_log_button"
                    (click)="addNew()"
                >
                    <app-svg-icon icon="add"> </app-svg-icon>
                    {{ "journal.add" | translate }}
                </button>
            }
        </div>
    </div>

    <div
        class="journal__body"
        (fileDropped)="createCommand && !readonly && onFileDropped($event)"
        appFileDragAndDrop
    >
        @if (data.length === 0) {
            <div class="journal__drop">
                <img
                    class="journal__drop__image"
                    src="../../../../../assets/icons/drop.svg"
                />
                <span class="journal__drop__label">{{ "general.dropFilesHere" | translate }}</span>
            </div>
        }

        <p-table
            class="journal__table"
            id="journal_table"
            #tableRef
            [columns]="relevantColumns"
            [hidden]="data.length === 0"
            [lazy]="isLazy"
            [loading]="loading"
            [metaKeySelection]="true"
            [pageLinks]="pageLinks"
            [paginator]="paginator"
            [rows]="internalRowCount"
            [scrollable]="scrollable"
            [selectionMode]="selectionMode"
            [sortOrder]="-1"
            [styleClass]="styleClass"
            [totalRecords]="total"
            [value]="data"
            (onLazyLoad)="loadTableRows($event)"
            (onRowSelect)="onRowSelect($event)"
            (onRowUnselect)="onRowDeselect($event)"
            dataKey="id"
            scrollHeight="flex"
            sortField="timestamp"
        >
            <ng-template pTemplate="emptymessage">
                @if (!loading && emptyMessage) {
                    <tr class="m-table-empty-message-row">
                        <td class="m-table-empty-message-cell">
                            <div>
                                <img
                                    class="m-table-empty-message-image"
                                    src="../../../../../assets/icons/drop.svg"
                                />
                            </div>
                            <div class="mt-8">
                                {{ "general.dropFilesHere" | translate }}
                            </div>
                        </td>
                    </tr>
                }
            </ng-template>

            <ng-template pTemplate="paginatorleft">
                @if (total) {
                    {{ "table.total" | translate }}: {{ total }}
                }
            </ng-template>

            @if (footer) {
                <ng-template pTemplate="summary">
                    @if (total && !paginator) {
                        {{ "table.total" | translate }}: {{ total }}
                    }
                </ng-template>
            }

            <ng-template
                class="test"
                [appTableRow]="data"
                let-journal
                let-rowIndex="rowIndex"
                pTemplate="body"
            >
                <tr
                    [pSelectableRow]="journal"
                    [pSelectableRowIndex]="rowIndex"
                >
                    <td style="padding: 8px">
                        <div class="m-card p-16 journal__entry">
                            <div class="journal__entry__info">
                                <div class="row">
                                    <p class="col-4">
                                        <strong>{{ "general.createdOn" | translate }}</strong>
                                    </p>
                                    @if (journal.timestamp) {
                                        <p
                                            class="col-8"
                                            style="margin-top: 0"
                                        >
                                            {{
                                                journal.timestamp
                                                    | momentDateTime: false : false : translateService.currentLang
                                            }}
                                            @if (journal.creator) {
                                                <span>
                                                    (<app-navigator [user]="journal.creator"></app-navigator>)
                                                </span>
                                            }
                                        </p>
                                    }
                                </div>

                                @if (journal.lastModificationDateTime) {
                                    <div class="row mt-8">
                                        <p class="col-4">
                                            <strong>{{ "general.modifiedOn" | translate }}</strong>
                                        </p>
                                        <p
                                            class="col-8"
                                            style="margin-top: 0"
                                        >
                                            {{
                                                journal.lastModificationDateTime
                                                    | momentDateTime: false : false : translateService.currentLang
                                            }}
                                            @if (journal.lastModifiedBy) {
                                                <span>
                                                    (<app-navigator [user]="journal.lastModifiedBy"></app-navigator>)
                                                </span>
                                            }
                                        </p>
                                    </div>
                                }

                                @if (canSetProject) {
                                    <div class="row mt-8">
                                        <p class="col-4">
                                            <strong>{{ "journal.project" | translate }}:</strong>
                                        </p>
                                        @if (canSetProject) {
                                            <p
                                                class="col-8"
                                                style="margin-top: 0"
                                            >
                                                {{ journal.project?.name || " " }}
                                            </p>
                                        }
                                    </div>
                                }

                                @if (journal.category || journal.subCategory) {
                                    <div class="row mt-8">
                                        <p class="col-4">
                                            <strong>{{ "journal.category" | translate }}:</strong>
                                        </p>
                                        <p
                                            class="col-8"
                                            style="margin-top: 0"
                                        >
                                            {{ journal.category.codeStringResourceId | translateModel }}
                                            @if (journal.category && journal.subCategory) {
                                                -
                                                {{ journal.subCategory.codeStringResourceId | translateModel }}
                                            }
                                        </p>
                                    </div>
                                }

                                @if (journal.isAdminOnly && canManageAdminJournal) {
                                    <p class="mt-8">
                                        <app-svg-icon
                                            icon="key-admin"
                                            tooltip="Admin only"
                                        >
                                        </app-svg-icon>
                                    </p>
                                }
                            </div>

                            <div class="journal__entry__remarks">
                                <p>
                                    <strong>{{ "journal.remarks" | translate }}</strong>
                                </p>
                                <p>{{ journal.remarks ? journal.remarks : "/" }}</p>

                                @if (canManageAdminJournal) {
                                    <p>
                                        <strong>{{ "journal.adminRemarks" | translate }}</strong>
                                    </p>
                                    <p>{{ journal.adminRemarks ? journal.adminRemarks : "/" }}</p>
                                }
                            </div>

                            <div class="journal__entry__actions flex gap-8">
                                @for (command of relevantCommands; track commandTrackByFn($index, command)) {
                                    @if (command.rowValidFunc(journal)) {
                                        <app-icon-button
                                            [disabled]="command.disabledFunc()"
                                            [icon]="command.icon"
                                            [text]="command.text"
                                            (click)="command.click(journal)"
                                        >
                                        </app-icon-button>
                                    }
                                }
                            </div>

                            <app-attachment-overview
                                class="journal__entry__attachments"
                                [context]="journal"
                            ></app-attachment-overview>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<app-journal-dialog />
